import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import RoleSelection from "@/pages/RoleSelection";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminTherapists from "@/pages/AdminTherapists";
import AdminReferrals from "@/pages/AdminReferrals";
import AdminContent from "@/pages/AdminContent";
import AdminPoints from "@/pages/AdminPoints";
import CorporateInquiries from "@/pages/CorporateInquiries";
import TherapistDashboard from "@/pages/TherapistDashboard";
import TherapistContent from "@/pages/TherapistContent";
import CustomerDashboard from "@/pages/CustomerDashboard";
import RewardsPage from "@/pages/RewardsPage";
import CreateReferral from "@/pages/CreateReferral";
import FamilyDependents from "@/pages/FamilyDependents";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Home page - shows role selection
const Home = () => {
  return <RoleSelection />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          
          {/* Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/therapists"
            element={
              <ProtectedRoute>
                <AdminTherapists />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/referrals"
            element={
              <ProtectedRoute>
                <AdminReferrals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/content"
            element={
              <ProtectedRoute>
                <AdminContent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/points"
            element={
              <ProtectedRoute>
                <AdminPoints />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/corporate"
            element={
              <ProtectedRoute>
                <CorporateInquiries />
              </ProtectedRoute>
            }
          />
          
          {/* Therapist Routes */}
          <Route
            path="/therapist/dashboard"
            element={
              <ProtectedRoute>
                <TherapistDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/therapist/referral/create"
            element={
              <ProtectedRoute>
                <CreateReferral userRole="therapist" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/therapist/content"
            element={
              <ProtectedRoute>
                <TherapistContent />
              </ProtectedRoute>
            }
          />
          
          {/* Customer Routes */}
          <Route
            path="/customer/dashboard"
            element={
              <ProtectedRoute>
                <CustomerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer/rewards"
            element={
              <ProtectedRoute>
                <RewardsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer/referral/create"
            element={
              <ProtectedRoute>
                <CreateReferral userRole="customer" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer/family"
            element={
              <ProtectedRoute>
                <FamilyDependents />
              </ProtectedRoute>
            }
          />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      
      {/* Toast Notifications */}
      <Toaster 
        position="top-right" 
        richColors 
        closeButton 
        toastOptions={{
          style: {
            fontFamily: 'IBM Plex Sans, sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
